import { customFieldCreateModalRoutingService } from 'components/CustomFieldCreateModal/contexts/CustomFieldCreateModal.ui.context';
import { customFieldEditModalRoutingService } from 'components/CustomFieldEditModal/contexts/CustomFieldModalEdit.ui.context';
import { ICustomFieldsSettingsComponentProps } from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettings.types';
import { createContext, FC, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import isUserPremiumSecondarySelector from 'store/selectors/userSelectors/isUserPremiumSecondarySelector';

const defaultProps: ICustomFieldsSettingsComponentProps = {
  isReadOnly: false,
  openCreateCustomFieldsModal: () => null,
  openEditCustomFieldsModal: (customFieldId) => null,
};

export const CustomFieldsSettingsComponentPropsContext =
  createContext<ICustomFieldsSettingsComponentProps>(defaultProps);

export const CustomFieldsSettingsComponentPropsProvider: FC = ({ children }) => {
  const isReadOnly = useSelector(isUserPremiumSecondarySelector);

  const contextValue = useMemo<ICustomFieldsSettingsComponentProps>(
    () => ({
      isReadOnly,
      openCreateCustomFieldsModal: () =>
        customFieldCreateModalRoutingService.open({}, 'CreateCustomFieldView'),
      openEditCustomFieldsModal: (customFieldId: string) =>
        customFieldEditModalRoutingService.open({ customFieldId }, 'EditCustomFieldView'),
    }),
    [isReadOnly],
  );

  return (
    <CustomFieldsSettingsComponentPropsContext.Provider value={contextValue}>
      {children}
    </CustomFieldsSettingsComponentPropsContext.Provider>
  );
};

export const useCustomFieldsSettingsComponentPropsContext =
  (): ICustomFieldsSettingsComponentProps => useContext(CustomFieldsSettingsComponentPropsContext);
